import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import ssoTheme from './theme/ssoTheme';
import RouteProvider from './layout/RouteProvider';
import store from './store';
import { getInitialRoute } from './common/jspGlobals';

// Set correct hash before React mounts — HashRouter reads this on boot.
// This replaces the old ProtectedRoute redirect-on-every-route-change pattern.
const initialRoute = getInitialRoute();
if (initialRoute) {
    window.location.hash = '#' + initialRoute;
}

const root = createRoot(document.getElementById('rootElementHolder'));
root.render(
    <ThemeProvider theme={ssoTheme}>
        <CssBaseline />
        <RouteProvider store={store} />
    </ThemeProvider>
);
